import { evaluate } from "./helper.js";

export const isValid = (item, values, interpreterItems) => {
  if (item.valid) {
    return evaluate(item.valid, values, interpreterItems);
  }
  return { result: true, aerrors: "" };
};

export const isHidden = (item, values, interpreterItems) => {
  if (item.hidden) {
    return evaluate(item.hidden, values, interpreterItems);
  }
  return { result: false, aerrors: "" };
};

export const isDisabled = (item, values, interpreterItems) => {
  if (item.disabled) {
    return evaluate(item.disabled, values, interpreterItems);
  }
  return { result: false, aerrors: "" };
};
/*
export const isExpressionTrue = (myInterpreter, expression, values, interpreterItems) => {
  return evaluate(myInterpreter, expression, null, values, interpreterItems).result;
};*/
